<div class="card" (click)="onCardClick()">
  <div class="card-header">
    <img src="{{ image }}" alt="Card Banner" class="icon" />
    <span
      class="text"
      [innerHTML]="'<b>' + (title | translate) + '</b>'"
    ></span>
  </div>
  <div class="card-body">
    <span [innerHTML]="description | translate"></span>
  </div>
  @if (moreInformation) {
    <div class="card-footer">
      <a href="#" (click)="openUrlLocalized($event); $event.stopPropagation()">
        {{ 'More Information' | translate }}
      </a>
    </div>
  }
</div>
